// Pure filtering for the App Catalog product list (platform_id=1 / madamefin
// products). Behaviour is specified in tests/unit/appCatalogFilter.spec.js.
//
//   status:    0 = all, 1 = active (status === 1), 2 = inactive (status === 2)
//   appFilter: 0 = all, 1 = sold in App (app_enable === 1), 2 = not in App
//
// "Sold in App" means app_enable === 1 (the product is published to the App
// catalog and synced to App PG). Any other value — including a missing field —
// counts as not-in-App. Keyword search is applied separately by the table's
// pagination mixin, so it is intentionally out of scope here.
export function filterAppCatalogProducts(rows, { status = 0, appFilter = 0 } = {}) {
  if (!Array.isArray(rows)) return [];
  return rows.filter((row) => {
    if (status !== 0 && row.status !== status) return false;
    const inApp = row.app_enable === 1;
    if (appFilter === 1 && !inApp) return false;
    if (appFilter === 2 && inApp) return false;
    return true;
  });
}

export default filterAppCatalogProducts;
